// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8a9fd300","455":"d3a5ec96","977":"df24baf8"}[chunkId] + ".chunk.js";
};